import {
  RESET_FILTERS_SERVICES,
  CHANGE_FILTER,
  SET_FILTERS,
  APPLY_FILTERS,
  APPLY_SERVICES_FILTERS,
  SEARCH_FILTERS,
  TOGGLE_SHOW_SERVICES,
  INITIALIZE_FILTERS,
  RESET_FILTERS,
  TOGGLE_SHOW_OFFICE_SERVICES,
} from '../constants';
import {
  filter,
  getPresentationalFilters,
  getPresentationalFiltersWithSortEnabledField,
} from '../../helpers/filtersHelpers';
import changeFilterMiddleware from '../../hooks/middlewares/changeFilterMiddleware';
import { searchServicesFilterMiddleware } from '../../hooks/actions/searchServicesFilter';
import { setServicesFilterMiddleware } from '../../hooks/actions/setServicesFilter';

const initialState = {
  data: {
    services: [],
    undergrounds: [],
    areas: [],
  },
  filters: {
    services: [],
    undergrounds: [],
    areas: [],
  },
  presentationalFilters: {
    services: [],
    undergrounds: [],
    areas: [],
  },
  searchValues: {
    services: '',
    areas: '',
    undergrounds: '',
  },
  offices: [],
  filteredOffices: [],
  presentationalOffices: [],
  selectedServicesCount: 0,
  showServices: false,
  showOfficeServices: false,
};

const applyFilters = (state) => {
  const { presentationalFilters, filters } = state;
  const presentationalOffices = filter(state.data.offices, filters);
  const newPresentationalFilters = Object.entries(presentationalFilters).reduce(
    (acc, [field, values]) => ({
      ...acc,
      [field]: getPresentationalFiltersWithSortEnabledField(
        values,
        filters[field]
      ),
    }),
    {}
  );
  return {
    ...state,
    filteredOffices: presentationalOffices,
    presentationalOffices,
    presentationalFilters: newPresentationalFilters,
  };
};

const resetFilters = (state) => {
  const { data, offices } = state;
  const { services, areas, undergrounds } = data;
  const presentationalFilters = {
    services: getPresentationalFilters(services, []),
    areas: getPresentationalFilters(areas, []),
    undergrounds: getPresentationalFilters(undergrounds, []),
  };
  return {
    ...state,
    filters: initialState.filters,
    filteredOffices: offices,
    presentationalOffices: offices,
    presentationalFilters,
  };
};

const filtersReducer = (state = initialState, action) => {
  /* eslint-disable no-case-declarations */
  switch (action.type) {
    case INITIALIZE_FILTERS:
      const { services, areas, undergrounds, offices } = action.payload;
      const presentationalFilters = {
        services: getPresentationalFilters(services, []),
        areas: getPresentationalFilters(areas, []),
        undergrounds: getPresentationalFilters(undergrounds, []),
      };
      const data = {
        services,
        areas,
        undergrounds,
        offices,
      };
      return {
        ...state,
        data,
        offices,
        presentationalOffices: offices,
        presentationalFilters,
      };

    case SET_FILTERS:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_FILTERS_SERVICES:
      return {
        ...state,
        filters: {
          ...state.filters,
          services: [],
        },
        presentationalFilters: {
          ...state.presentationalFilters,
          services: getPresentationalFilters(state.data.services, []),
        },
      };
    case SEARCH_FILTERS: {
      return searchServicesFilterMiddleware(action, state);
    }
    case CHANGE_FILTER:
      return changeFilterMiddleware(action, state);
    case APPLY_FILTERS:
      return applyFilters(state, action);
    case APPLY_SERVICES_FILTERS:
      const { fieldName, ids } = action.payload;
      return {
        ...state,
        filters: {
          ...state.filters,
          [fieldName]: ids,
        },
      };
    case TOGGLE_SHOW_SERVICES: {
      return {
        ...setServicesFilterMiddleware(action, state),
        showServices: action.payload.value,
      };
    }
    case TOGGLE_SHOW_OFFICE_SERVICES: {
      return {
        ...setServicesFilterMiddleware(action, state),
        showOfficeServices: action.payload.value,
      };
    }
    case RESET_FILTERS:
      return {
        ...resetFilters(state),
      };
    default:
      return state;
  }
  /* eslint-enable */
};

export default filtersReducer;
